import React from 'react';
import { FieldProps } from 'formik';
import cn from 'classnames';
import InputMask, { MaskOptions } from 'react-input-mask';

interface IProps {
  mask?: string;
}

const TextField: React.SFC<FieldProps & IProps & MaskOptions> = ({
  field, // { name, value, onChange, onBlur }
  form: { touched, errors }, // also values, setXXXX, handleXXXX, dirty, isValid, status, etc.
  ...props
}) => {
  if (props.mask) {
    return (
      <InputMask
        mask={props.mask}
        className={cn({ 'input-error': touched[field.name] && errors[field.name] })}
        // disabled={isSubmitting}
        {...field}
        {...props}
      />
    );
  }
  return (
    <input
      className={cn({ 'input-error': touched[field.name] && errors[field.name] })}
      type="text" {...field} {...props}
      // disabled={isSubmitting}
    />
  );
};

export default TextField;
